import request from '../utils/request';

//展具列表
export function getGreenList(data) {
  return request({
    url: '/frontExhibitor/greenEquipment/list?lang='+data,
    method: 'get',
  
  });
}

//获取展位信息
export function getexAddress() {
  return request({
      url: '/frontExhibitor/exhibitor/viewBoothInformation',
      method: 'get',
  });
}

//提交展具信息
export function sumitEXMsg(data) {
  return request({
      url: '/frontExhibitor/greenEquipment/save',
      method: 'post',
      data:data
  });
};

//我的租赁--展具绿植
export function lease(data) {
  return request({
      url: '/frontExhibitor/greenEquipment/theExhibitionEquipmentIRented',
      method: 'get',
      params:data
  });
}

//-----------------------------------------绿植部分-------------------------------------------











